import Vue from "vue";
import VueRouter from "vue-router";
import Admin from "@/modules/admin/general/Admin.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../modules/tienda/views/Home.vue"),
  },
  {
    path: "/categoria/:nombre_categoria",
    name: "categoria",
    component: () => import("../modules/tienda/views/Categoria.vue"),
  },

  {
    path: "/subcategoria/:nombre_subcategoria",
    name: "subcategoria",
    component: () => import("../modules/tienda/views/Productos.vue"),
  },

  {
    path: "/subcategoria/:nombre_subcategoria/:id_producto",
    name: "subcategoria",
    component: () => import("../modules/tienda/views/ViewProducto.vue"),
  },
  {
    path: "/admin",
    component: Admin,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/",
        name: "homeAdmin",
        meta: {
          requiresAuth: true,
        },
        component: () => import("../modules/admin/general/Dashboard.vue"),
      },
      {
        path: "dashboard",
        meta: {
          requiresAuth: true,
        },
        name: "dashboard",
        component: () => import("../modules/admin/general/Dashboard.vue"),
      },
      {
        path: "productos",
        name: "administrar-productos",
        meta: {
          requiresAuth: true,
        },
        component: () => import("../modules/admin/productos/Productos.vue"),
      },
      {
        path: "config-banner",
        name: "configBanner",
        meta: {
          requiresAuth: true,
        },
        component: () => import("../modules/admin/general/ConfigBanner.vue"),
      },
    ],
  },
  {
    path: "/admin/login",
    name: "login",
    component: () => import("../modules/admin/login/Login.vue"),
  },
  {
    path: "**",
    name: "not-found",
    component: () => import("../modules/admin/general/NotFoundView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (store.state.token_colimp != null) {
      next();
    } else {
      next("/admin/login");
    }
  } else {
    next();
  }
});

export default router;
